module.exports = __webpack_public_path__ + "static/media/r2.30446b55.png";